

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigProvider } from '../../shared/services/configprovider';
import { urls } from '../../common/model/properties';
import { SecureStorageService } from '../../secure-storage.service';

@Injectable()
export class ProviderOutreachService {

  providerList: any;
  props: any;
  constructor(private http: HttpClient,
    private secureStorage: SecureStorageService,
    private configProvider: ConfigProvider) {
    this.props = configProvider.getProps();
  }

  //   async getAddress1(id): Promise<any> {
  //    const headers = new HttpHeaders();
  //    const ppjwt = JSON.parse(sessionStorage.currentUser);
  //    headers.set('Authorization', 'Bearer ' +  ppjwt.access_token);
  //    headers.set('Content-Type', 'application/json');
  //    headers.set('Allow-Access-Control-Origin', '*');
  //   let myParams = new URLSearchParams();
  //    const providerList = {
  //      "ProviderIDList": [id]
  //    };
  //     myParams.append('memberUid', this.providerList);
  //    return this.http.post(urls.getProviderAddress,providerList,{headers: headers}).toPromise();
  // }

  async getAddress(id): Promise<any> {
    //id="100000000267"
    const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + ppjwt.access_token,
      'Content-Type': 'application/json',
      'Allow-Access-Control-Origin': '*'
    });


    const providerList = {
      "ProviderIDList": id
      //"ProviderIDList": ["100000000267"]
    };
    let myParams = new HttpParams()
      .append('memberUid', this.providerList);
    return this.http.post(urls.getProviderAddress, providerList, { headers: headers }).toPromise();
  }



 getPdmData(id) {

  const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
  const headers = new HttpHeaders({
    'Authorization': 'Bearer ' + ppjwt.access_token,
    'Content-Type': 'application/json',
  });


  const providerList = {
    "ProviderIDList": id
    
  };

  return this.http.post(urls.getProviderAddress, providerList, { headers: headers });
}

}